/**
 *
 * takeLatestPerEntity
 * Like takeLatest, but a new action only cancels a pending one for the same
 * entity. A plain takeLatest on LIST_ENTITY let a locations list cancel a
 * routes list (and vice versa), leaving that entity with stale data.
 *
 */

import { cancel, fork, take } from 'redux-saga/effects';

function* watchLatestPerEntity(pattern, worker) {
  const tasks = {};
  for (;;) {
    const action = yield take(pattern);
    const entity = action.options?.entity;
    if (tasks[entity]) {
      yield cancel(tasks[entity]);
    }
    tasks[entity] = yield fork(worker, action);
  }
}

export default function takeLatestPerEntity(pattern, worker) {
  return fork(watchLatestPerEntity, pattern, worker);
}
